import { Stack, Typography } from '@mui/material';

import { PaperWithShadow } from '../../components/general/PaperWithShadow.tsx';
import { StickyWrapperWithBlur } from '../../components/general/StickyWrapper';
import { type ThemaFromThemaRouter } from '../../dtos';
import { isBlendedLearning } from '../../utils/isBlendedLearning';

type VeranstaltungPlanungHeaderProps = {
  readonly thema: ThemaFromThemaRouter;
};

export const VeranstaltungPlanungHeader = ({ thema }: VeranstaltungPlanungHeaderProps) => {
  const entityLabel = isBlendedLearning(thema.strukturellesFormat) ? 'Durchgang' : 'Veranstaltung';

  return (
    <StickyWrapperWithBlur sx={{ mt: -2, width: '100%' }}>
      <PaperWithShadow>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ height: '34px' }}>
          <Stack direction="column" spacing={1}>
            <Typography variant="headingXs">{entityLabel} anlegen</Typography>
          </Stack>
        </Stack>
      </PaperWithShadow>
    </StickyWrapperWithBlur>
  );
};
